import { TMentionUser } from '@onesource/schemas';

import axios from '../axios';

interface FetchMentionUsersOptions {
  instructorsOnly?: boolean;
  /** Leave the caller out of the results (e.g. the block search). */
  excludeSelf?: boolean;
}

export const fetchMentionUsers = async (
  query: string,
  options: FetchMentionUsersOptions = {},
): Promise<TMentionUser[]> => {
  const params: Record<string, string> = { q: query };
  if (options.instructorsOnly) {
    params.instructorsOnly = 'true';
  }
  if (options.excludeSelf) {
    params.excludeSelf = 'true';
  }

  const res = await axios.get<TMentionUser[]>('/mention/users', { params });

  return res.data;
};

export const fetchInstructorMentionUsers = (query: string): Promise<TMentionUser[]> => {
  return fetchMentionUsers(query, { instructorsOnly: true });
};

/**
 * Community-hub mention search scoped to a single space. Only returns users who
 * are members of the space's access group.
 */
export const fetchSpaceMentionUsers = async (spaceId: string, query: string): Promise<TMentionUser[]> => {
  const res = await axios.get<TMentionUser[]>(`/community-hub/spaces/${spaceId}/mention/users`, {
    params: { q: query },
  });

  return res.data;
};
